// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__17RDJ","errorLogs":"EditorFooter_errorLogs__3zdqB"};